/**
 * Content policy field definitions
 * @module content-policy/fields
 */
import * as Yup from 'yup'
import { Map } from 'immutable'

export const contentPolicySchema = Yup.object({
  name: Yup.string()
    .max(255, 'Must be less than 255 characters')
    .required('Required'),
})

export function getInitialValues (contentPolicy = Map(), options = {}) {
  const { isNew = false } = options
  return {
    policyId: isNew ? '' : contentPolicy.get('policyId') || '',
    name: contentPolicy.get('name') || '',
    shareAllowed: contentPolicy.get('shareAllowed') || false,
    countries: contentPolicy.get('countries') || [],
    availability: contentPolicy.get('availability') || '',
    optionIds: contentPolicy.get('optionIds') || [],
  }
}
